// extracted by mini-css-extract-plugin
module.exports = {"ArticleMedia":"ArticleMedia__2S5BO","ArticleMedia_caption":"ArticleMedia_caption__2S5BO","ArticleMedia_mediabox":"ArticleMedia_mediabox__2S5BO"};